import { render, staticRenderFns } from "./GsEventDataView.vue?vue&type=template&id=243e0ed5&"
import script from "./GsEventDataView.vue?vue&type=script&lang=js&"
export * from "./GsEventDataView.vue?vue&type=script&lang=js&"
import style0 from "./GsEventDataView.vue?vue&type=style&index=0&id=243e0ed5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports